import { useEffect, useState } from 'react';
import { Form, ResourceContextProvider, useNotify } from 'react-admin';
import { FieldValues } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { typedHttpClient } from '../../../utils/httpClient';
import { ConfigType, DefinitionType } from '../../../lib/constants/typedApiReturnTypes';
import { ClientConfigFormGenerator } from '../../../lib/clientConfigFormGenerator';
import {
  saveClientConfigDefaults,
} from '../../../lib/clientConfigHelpers';
import authProvider from '../../../utils/authProvider';

export const KioskDefaults = () => {

  const [definition, setDefinition] = useState<DefinitionType | null>(null);
  const [config, setConfig] = useState<ConfigType | undefined>();
  const [updateTimestamp, setUpdateTimestamp] = useState<number>(0);
  const notify = useNotify();
  const navigate = useNavigate();
  const isDevAdmin = authProvider.isDeveloperAdmin();

  useEffect(() => {

    if (!isDevAdmin) {

      notify('resources.config.text.no_access');
      navigate(-1);

    }

  }, [isDevAdmin]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {

    typedHttpClient().clientConfig.clientConfigControllerResolveKioskDefaultConfigV0().then((response) => {

      setDefinition(response.data.definition ?? null);
      setConfig(response.data.config);

    });

  }, [updateTimestamp]);

  const updateConfig = async (values: FieldValues) => {

    if (!definition) {

      return;

    }

    const hasError = await saveClientConfigDefaults(
      'kiosk',
      0,
      definition,
      config as Record<string, unknown> | undefined,
      values as Record<string, unknown>,
    );
    if (hasError) {

      notify('resources.config.text.defaults_update_error', { type: 'error' });

    } else {

      notify('resources.config.text.defaults_updated');

    }
    setUpdateTimestamp(Date.now());

  };

  return (
    <div>
      <h1>KioskConfig</h1>
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <ResourceContextProvider value={'ClientConfig'}>
        {/* noValidate: collapsed groups use display:none; browser HTML5 validation cannot focus required hidden inputs */}
        <Form noValidate reValidateMode={'onChange'} record={config} mode="onBlur" onSubmit={updateConfig}>
          {definition && <ClientConfigFormGenerator definitions={definition} />}
        </Form>
      </ResourceContextProvider>
    </div>
  );

};
